import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints' // TODO: migrate to @sunwebgroup/uds-ui when available
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import styles from './LegalDisclamer.module.css'

export function LegalDisclamer() {
  const [showModal, setShowModal] = React.useState(false)
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { isTablet } = useBreakpoints()
  const sheetWrapperSide = isTablet ? 'right' : 'bottom'

  const handleModalClose = (isOpen: boolean) => {
    setShowModal(isOpen)
    sendEvent(
      createPDPClickEvent(
        isOpen
          ? {
              element: 'Modal',
              description: 'Show legal information about the reviews',
              result: 'Modal with legal information opened',
              type: 'Reviews legal information modal',
            }
          : {
              element: 'Modal',
              description: 'Hide legal information about the reviews',
              result: 'Modal with legal information closed',
              type: 'Reviews legal information modal',
            },
      ),
    )
  }

  return (
    <p className={styles.wrapper}>
      <Typography as="span" variant="body-m-regular-snug">
        {intl.formatMessage({ id: 'reviews_teaser_legal_disclaimer' })}
        {' '}
      </Typography>
      <Sheet.Root open={showModal} onOpenChange={handleModalClose}>
        <Sheet.Trigger>
          <Typography as="button" role="button" variant="body-m-regular-snug" className={styles.clickableText}>
            {intl.formatMessage({ id: 'reviews_teaser_legal_disclaimer_link' })}
          </Typography>
        </Sheet.Trigger>
        <Sheet.Body side={sheetWrapperSide}>
          <Sheet.Header
            closeLabel={intl.formatMessage({ id: 'close' })}
            titleLabel={intl.formatMessage({ id: 'reviews_legal_disclaimer_title' })}
          />
          <Sheet.Content>
            <RichText tag="span" innerHTML={intl.formatMessage({ id: 'reviews_legal_disclaimer_html' })} />
          </Sheet.Content>
        </Sheet.Body>
      </Sheet.Root>
    </p>
  )
}
